import { type } from "@testing-library/user-event/dist/type";
import trainActionTypes from "./train.types";

const INITIAL_STATE = {
    railyatriId: undefined,
    detailsData: [],
    isFetchingDetailsData: false,
    detailsFetchErrorMessage: undefined,
    urlData: undefined,
    offset: 5,
    type: undefined,
    bugText: undefined,
    feedbackText: undefined,
    postSuccessResponse: [],
    postFailErrorMessage: undefined,
    isPosting: false,
    bugimgs: '',
    feedbackimgs: '',
    loggedIn: false,
}

const trainReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case trainActionTypes.DETAILS_FETCH_START:
            return {
                ...state,
                isFetchingDetailsData: true
            }
        case trainActionTypes.LOGGED_IN:
            return {
                ...state,
                loggedIn: true
            }
        case trainActionTypes.DETAILS_FETCH_SUCCESS:
            return {
                ...state,
                isFetchingDetailsData: false,
                detailsData: action.payload
            }
        case trainActionTypes.DETAILS_FETCH_FAIL:
            return {
                ...state,
                isFetchingDetailsData: false,
                detailsFetchErrorMessage: action.payload
            }
        case trainActionTypes.SET_RAILYATRI_ID:
            return {
                ...state,
                railyatriId: action.payload
            }
        case trainActionTypes.SET_URL_DATA:
            return {
                ...state,
                urlData: action.payload
            }
        case trainActionTypes.SET_OFFSET:
            return {
                ...state,
                offset: state.offset + 50
            }
        case trainActionTypes.SET_TYPE:
            return {
                ...state,
                type: action.payload
            }
        case trainActionTypes.SET_BUG_TEXT:
            return {
                ...state,
                bugText: action.payload
            }
        case trainActionTypes.SET_FEEDBACK_TEXT:
            return {
                ...state,
                feedbackText: action.payload
            }
        case trainActionTypes.SEND_POST_START:
            return {
                ...state,
                isPosting: true
            }
        case trainActionTypes.DETAILS_FETCH_SUCCESS:
            return {
                ...state,
                isPosting: false,
                postSuccessResponse: action.payload
            }
        case trainActionTypes.DETAILS_FETCH_FAIL:
            return {
                ...state,
                isPosting: false,
                postFailErrorMessage: action.payload
            }
        case trainActionTypes.SET_IMAGES_BUG:
            return {
                ...state,
                bugimgs: action.payload
            }
        case trainActionTypes.SET_IMAGES_FEEDBACK:
            return {
                ...state,
                feedbackimgs: action.payload
            }
        default:
            return state;
    }
}

export default trainReducer;